import { Fragment } from "react";
import { Link } from "react-router-dom";
import SiteFooter from "@/site/SiteFooter";
import Brief from "@/site/Brief";
import Pains from "@/site/Pains";
import Faq from "@/site/Faq";
import StepsRail from "@/site/StepsRail";
import { ServiceCards } from "@/site/ServiceCards";
import WorkCards from "@/site/WorkCards";
import { useBrief, useSceneMount } from "@/site/hooks";
import { useForge } from "@/site/useForge";
import { useT, useLangPath } from "@/i18n";

/** Landing-ul.
 *
 *  Structura urmează drumul cumpărătorului, nu ordinea în care îmi place mie să
 *  vorbesc: se recunoaște în propria problemă, vede că am livrat, află cum
 *  lucrez, primește răspuns la preț și durată, apoi scrie.
 *
 *  Lista de lucrări arată rezultatul, nu stiva. Înainte scria „Electron ·
 *  PostgreSQL 43 tables · TREMOL S" — numărul de tabele din baza de date e o
 *  cifră care mă interesează pe mine, nu pe cine cumpără. */
export default function Home() {
  const t = useT();
  const lp = useLangPath();
  const goBrief = useBrief();
  /* Fără model 3D pe landing. Scenele existente aparțin fiecare unui proiect
     anume — sunt construite pentru pagina lui de caz, cu camera, materialele și
     coregrafia lui. Mutată în hero, oricare dintre ele e un obiect specific
     lipit într-un slot generic: arată reciclat, fiindcă e reciclat. Hero-ul își
     merită propriul limbaj vizual, nu împrumutul altei pagini. */
  const { rootRef, billetRef, canvasRef, h1Ref } = useForge();
  useSceneMount(null)
  return (
    <div className="page on">
      {/* Hero-ul.
          Avea patru tipare care apar pe orice pagină generată: supratitlu cu
          liniuță aurie deasupra titlului, ultimul rând al titlului colorat în
          accent, o pereche buton plin + buton fantomă, și — cauza reală a
          jumătății goale din dreapta — h1 închis într-o coloană de 18ch.

          Acum titlul ține toată lățimea pe două rânduri, aurul e doar punctul
          final (un semn, nu un cuvânt evidențiat), iar sub el compoziția se
          împarte în două: textul și acțiunea la stânga, cifrele studioului la
          dreapta. Supratitlul a ieșit — „Independent engineering studio" scria
          deja în subsol, iar titlul plus subtitlul spun ce e asta. */}
      {/* HERO — „Fibraj: piesa lucrată".
          Materialul e o felie de oțel forjat, secționată, cu muchii de tăiere
          reale sus și jos. Fibrele se încovoaie în jurul titlului; unde treci
          cu mâna, metalul se deformează ireversibil și se încălzește spre
          auriu, apoi se răcește la loc.

          Compoziția face parte din design, nu doar canvasul: baseline-ul
          rândului doi cade exact la 62% din înălțimea feliei, fiindcă acolo
          trece lovitura de la încărcare. De asta titlul e poziționat absolut
          față de felie, nu așezat în flux. */}
      <section className="hero" ref={rootRef}>
        <div className="billet" aria-hidden="true" ref={billetRef}>
          <canvas className="forgecv" ref={canvasRef} aria-hidden="true" />
        </div>

        <div className="herostage">
          <div className="heroshell">
            <h1 ref={h1Ref}>
              {/* <br> stă ÎNTRE spanuri, nu în ele: .hline e inline-block, iar
                  o rupere din interiorul cutiei rupe în cutie, nu între ele —
                  cele două rânduri ajungeau lipite pe unul singur. */}
              {t.home.h1.map((line, i) => (
                <Fragment key={i}>
                  {/* Spațiul dinaintea rupturii nu se vede — orice spațiu de la
                      capătul unui rând se pierde la randare — dar există în text.
                      Fără el, extragerea textului lipea rândurile: „Software
                      forgedfor production." Așa vede Bing titlul, și tot așa îl
                      citește un model care ia pagina ca text. */}
                  {i > 0 ? <>{" "}<br /></> : null}
                  <span className="hline">
                    {/* Punctul final e singurul lucru auriu din titlu. Se taie
                        din ultimul rând, deci nu cere un câmp separat în
                        dicționar și merge la fel în toate trei limbile. */}
                    {i === t.home.h1.length - 1 && line.endsWith(".")
                      ? <>{line.slice(0, -1)}<em className="em" style={{ fontStyle: "normal" }}>.</em></>
                      : line}
                  </span>
                </Fragment>
              ))}
            </h1>

            <div className="sublock">
              <p className="sub">{t.home.sub}</p>

              <div className="actions">
                <button type="button" className="herocta herocta-a" onClick={goBrief}>
                  {t.home.ctaStart}
                </button>
                <a className="herocta herocta-b" href="#work">
                  {t.home.ctaWork} <span className="heroarrow" aria-hidden="true">→</span>
                </a>
              </div>

              <div
                className="figs"
                role="group"
                aria-label={t.home.scale.map((x) => `${x.n} ${x.l}`).join(", ")}
              >
                {t.home.scale.map((x, i) => (
                  <Fragment key={x.l}>
                    {i > 0 ? <span className="figsep" aria-hidden="true">·</span> : null}
                    <span className="fig"><b>{x.n}</b> {x.l}</span>
                  </Fragment>
                ))}
              </div>
            </div>
          </div>
        </div>

      </section>

      <section className="sec" id="pains">
        <div className="sechead"><h2>{t.home.painsHead}</h2></div>
        <Pains />
      </section>

      <section className="sec" id="services">
        <div className="sechead"><h2>{t.home.servicesHead}</h2></div>
        <ServiceCards />
        <Link className="seeall act act-b act-sm" to={lp("/services")}>{t.seeAll.services} <span aria-hidden="true">→</span></Link>
      </section>

      {/* Vârful paginii, și acum răspunsul la Services.
          Șase din opt secțiuni aveau aceeași formă — supratitlu, titlu, grilă de
          carduri egale — deci nimic nu era punctul paginii. Asta e singura cu
          imagini: e ce am livrat, adică singurul argument care nu e o afirmație
          despre mine.

          Stă după Services, nu înainte: întâi ce fac, apoi dovada că am făcut-o.
          În ordinea dinainte cazurile veneau fără context — vizitatorul vedea
          patru proiecte înainte să știe ce se poate cere. */}
      <section className="sec secpeak" id="work">
        <div className="sechead"><h2>{t.home.workHead}</h2></div>
        <WorkCards />
        <Link className="seeall act act-b act-sm" to={lp("/work")}>{t.seeAll.work} <span aria-hidden="true">→</span></Link>
      </section>

      <section className="sec" id="process">
        <div className="sechead stepshead">
          <div className="eyebrow">{t.home.stepsEyebrow}</div>
          <h2>{t.home.stepsHead}</h2>
        </div>
        {/* Pașii spun ce se întâmplă cu frica ta, nu ce activitate urmează.

            Cifra uriașă din rigolă e DECOR — aria-hidden — și pornește goală,
            doar contur. Se umple când șina condusă de scroll trece de ea, și
            rămâne umplută. Ordinalul care contează e cel din eticheta mono,
            citit de cititoarele de ecran. */}
        <div className="steps">
          <StepsRail />
          {t.home.steps.map((s) => (
            <div className="stp" key={s.n}>
              <span className="ord" aria-hidden="true">{s.n}</span>
              <div className="stpbody">
                <h3><span className="stpn">{s.n}</span> · {s.h}</h3>
                <p>{s.p}</p>
              </div>
            </div>
          ))}
        </div>
      </section>

      {/* Titlul stă în componentă, lângă întrebări: capul de secțiune are acum
          un rând deasupra, iar ținerea lor împreună evită să se despartă. */}
      {/* Doar primele patru: aceleași șapte întrebări pe două adrese ar face
          landing-ul și /faq să concureze pe aceleași căutări. */}
      <section className="sec" id="faq">
        <Faq limit={4} />
        <Link className="seeall act act-b act-sm" to={lp("/faq")}>{t.seeAll.faq} <span aria-hidden="true">→</span></Link>
      </section>

      <section className="sec" id="brief">
        <div className="sechead"><h2>{t.home.briefHead}</h2></div>
        <Brief />
      </section>

      <SiteFooter />
    </div>
  );
}
